/* ==========================================================
   MUCUMU Shopify Theme — mucumu-theme.js
   Combines all interactions from script.js + product.js
   with Shopify cart AJAX, variant updates, and drawer logic.
   ========================================================== */

(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ============================================================
     BLOCK HORIZONTAL PAGE PAN (iOS Safari fix)
     Prevents the whole page from panning sideways while still
     allowing legitimate horizontal carousels to scroll.
  ============================================================ */
  (function () {
    let startX = 0, startY = 0, decided = false, isHoriz = false;

    document.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      decided = false;
      isHoriz = false;
    }, { passive: true });

    document.addEventListener('touchmove', (e) => {
      if (!decided) {
        const dx = Math.abs(e.touches[0].clientX - startX);
        const dy = Math.abs(e.touches[0].clientY - startY);
        if (dx < 4 && dy < 4) return;
        isHoriz = dx > dy;
        decided = true;
      }
      if (!isHoriz) return; // vertical — always allow

      // Walk up the tree: if a scrollable horizontal container is found, allow
      let el = e.target;
      while (el && el !== document.documentElement) {
        const ox = window.getComputedStyle(el).overflowX;
        if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth) return;
        el = el.parentElement;
      }

      e.preventDefault(); // no scrollable ancestor → block page pan
    }, { passive: false });
  }());

  /* ============================================================
     STICKY NAV SCROLL STATE
  ============================================================ */
  const nav = $('.nav');
  if (nav) {
    const onScroll = () => {
      if (window.scrollY > 40) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     ANNOUNCEMENT BAR ROTATOR
  ============================================================ */
  const msgs = $$('.announce-msg');
  if (msgs.length) {
    let curMsg = 0;
    msgs[0].classList.add('is-active');
    setInterval(() => {
      msgs[curMsg].classList.remove('is-active');
      curMsg = (curMsg + 1) % msgs.length;
      msgs[curMsg].classList.add('is-active');
    }, 4000);
  }

  /* ============================================================
     MEGA MENUS
  ============================================================ */
  function setupMega(triggerSel, menuSel) {
    const trigger = $(triggerSel);
    const menu = $(menuSel);
    if (!trigger || !menu) return;
    let timer;
    const open = () => {
      clearTimeout(timer);
      $$('.mega, .mega-mini').forEach(m => m.classList.remove('is-open'));
      $$('.nav-link').forEach(l => l.classList.remove('is-open'));
      menu.classList.add('is-open');
      trigger.classList.add('is-open');
    };
    const close = () => {
      timer = setTimeout(() => {
        menu.classList.remove('is-open');
        trigger.classList.remove('is-open');
      }, 120);
    };
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('click', (e) => {
      if (menu.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        trigger.classList.remove('is-open');
      } else {
        e.preventDefault();
        open();
      }
    });
    menu.addEventListener('mouseenter', () => clearTimeout(timer));
    menu.addEventListener('mouseleave', close);
    trigger.addEventListener('mouseleave', close);
  }

  setupMega('#nav-shop', '#mega-shop');
  setupMega('#nav-scent', '#mega-scent');

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav')) {
      $$('.mega, .mega-mini').forEach(m => m.classList.remove('is-open'));
      $$('.nav-link').forEach(l => l.classList.remove('is-open'));
    }
  });

  /* ============================================================
     HERO TOAST DISMISS
  ============================================================ */
  $('.toast-close')?.addEventListener('click', () => {
    $('.toast')?.classList.add('is-hidden');
  });

  /* ============================================================
     CAROUSELS
  ============================================================ */
  $$('.carousel-wrap').forEach((wrap) => {
    const carousel = $('.carousel', wrap);
    const scope = wrap.closest('section') || wrap.parentElement;
    const prev = scope ? scope.querySelector('.carousel-btn.prev') : null;
    const next = scope ? scope.querySelector('.carousel-btn.next') : null;
    const bar = $('.carousel-progress-bar', wrap);
    if (!carousel) return;

    const scrollByAmount = () => {
      const card = carousel.firstElementChild;
      if (!card) return 320;
      const styles = getComputedStyle(carousel);
      const gap = parseInt(styles.columnGap || styles.gap || '20', 10);
      return (card.offsetWidth + gap) * Math.max(1, Math.floor(carousel.clientWidth / (card.offsetWidth + gap)));
    };

    prev?.addEventListener('click', () => carousel.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => carousel.scrollBy({ left: scrollByAmount(), behavior: 'smooth' }));

    const updateProgress = () => {
      if (!bar) return;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const ratio = maxScroll > 0 ? carousel.scrollLeft / maxScroll : 0;
      const visibleFrac = carousel.clientWidth / carousel.scrollWidth;
      const widthPct = Math.max(0.15, Math.min(1, visibleFrac));
      bar.style.width = (widthPct * 100) + '%';
      bar.style.left = (ratio * (1 - widthPct) * 100) + '%';
      if (prev) prev.disabled = carousel.scrollLeft <= 2;
      if (next) next.disabled = carousel.scrollLeft >= maxScroll - 2;
    };
    carousel.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  });

  /* ============================================================
     UGC AUTO-SCROLL
  ============================================================ */
  document.querySelectorAll('#ugc-track, #ugc-track-pdp, #collab-projects-track').forEach(track => {
    if (!track) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const cards = Array.from(track.querySelectorAll('.ucard'));
    if (cards.length === 0) return;

    // Build belt: originals + clones for seamless loop
    const belt = document.createElement('div');
    belt.style.cssText = 'display:flex;gap:12px;width:max-content;will-change:transform;';

    cards.forEach(c => belt.appendChild(c));
    cards.forEach(c => {
      const clone = c.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      belt.appendChild(clone);
    });
    track.appendChild(belt);
    track.classList.add('ugc-auto');

    // Measure after layout and inject animation
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const halfW = belt.scrollWidth / 2;
      const duration = halfW / 72; // ~72px/s

      const style = document.createElement('style');
      style.textContent = `@keyframes ugcScroll{from{transform:translateX(0)}to{transform:translateX(-${halfW}px)}}`;
      document.head.appendChild(style);

      belt.style.animation = `ugcScroll ${duration}s linear infinite`;
    }));
  });

  /* ============================================================
     SEARCH OVERLAY
  ============================================================ */
  const searchOverlay = $('#search-overlay');

  const openSearch = () => {
    searchOverlay?.classList.add('is-open');
    document.documentElement.classList.add('scroll-locked');
    setTimeout(() => $('#search-input')?.focus(), 100);
  };
  const closeSearch = () => {
    searchOverlay?.classList.remove('is-open');
    document.documentElement.classList.remove('scroll-locked');
  };

  $$('.search-trigger').forEach(b => b.addEventListener('click', openSearch));
  $('#search-close')?.addEventListener('click', closeSearch);

  /* Popular search suggest — delegated on overlay so it works regardless of render timing */
  searchOverlay?.addEventListener('click', (e) => {
    const btn = e.target.closest('.search-suggest');
    if (!btn) return;
    const input = $('#search-input');
    if (!input) return;
    input.value = btn.textContent.trim();
    if (btn.dataset.term) input.dataset.overrideQ = btn.dataset.term;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });

  /* Live search — debounced fetch */
  let searchTimer;
  $('#search-input')?.addEventListener('input', (e) => {
    clearTimeout(searchTimer);
    const q = e.target.dataset.overrideQ || e.target.value.trim();
    delete e.target.dataset.overrideQ;
    if (q.length < 2) return;
    searchTimer = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
        .then(r => r.json())
        .then(data => {
          // Update search results — handled by Shopify predictive search API
          const results = data.resources?.results?.products || [];
          const grid = $('.search-products');
          if (!grid || !results.length) return;
          /* price from /search/suggest.json is a euro string like "40.00", not cents */
          const fmtPrice = v => '€ ' + parseFloat(v).toFixed(2).replace('.', ',');
          grid.innerHTML = results.map(p => `
            <a class="pcard" href="${p.url}">
              <div class="pcard-image">
                <img class="mucumu-search-result-img" src="${p.featured_image?.url || ''}" alt="${p.title}" loading="lazy">
              </div>
              <div class="pcard-meta">
                <span class="pcard-scent">${p.vendor}</span>
                <h3 class="pcard-title">${p.title}</h3>
                ${(()=>{ const t=p.variants?.[0]?.title||''; if(t&&t!=='Default Title')return`<p class="pcard-notes">${t}</p>`; const f=p.options_with_values?.[0]?.values?.[0]||''; return f?`<p class="pcard-notes">${f}</p>`:''; })()}
                <div class="pcard-foot">
                  <span class="pcard-price">${fmtPrice(p.price)}</span>
                </div>
              </div>
            </a>`).join('');
        })
        .catch(() => {});
    }, 280);
  });

  /* ============================================================
     SHOPIFY CART AJAX
  ============================================================ */
  const drawer = $('#cart-drawer');
  const drawerBackdrop = $('#drawer-backdrop');

  function updateCartCount(count) {
    $$('.bag-count').forEach(el => {
      el.textContent = count;
      el.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
        { duration: 320, easing: 'cubic-bezier(0.22,0.61,0.36,1)' }
      );
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, '€ {{amount}}');
    }
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }
  window.MucumuFormatMoney = formatMoney;

  function renderCartDrawer(cart) {
    const head = drawer?.querySelector('.drawer-head h4');
    const body = drawer?.querySelector('.drawer-body');
    const foot = drawer?.querySelector('.drawer-foot');

    if (head) {
      head.innerHTML = `Tvoj košík <span style="color:var(--ink-mute);margin-left:8px;">(${cart.item_count})</span>`;
    }

    if (cart.item_count === 0) {
      if (body) {
        body.classList.remove('has-items');
        body.innerHTML = `
          <div class="empty-mark">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
              <path d="M3 6h18l-2 12H5L3 6z"/><path d="M9 6V4a3 3 0 0 1 6 0v2"/></svg>
          </div>
          <p>Tvoj košík je zatiaľ prázdny.</p>
          <span class="sub">Nájdi svoju signature vôňu a začni rituál.</span>
          <a class="btn btn-dark btn-sm" href="/collections/all" style="margin-top:8px;">Objaviť bestsellery →</a>`;
      }
      if (foot) {
        foot.innerHTML = `
          <div class="mucumu-subtotal"><span>Medzisúčet</span><strong>€ 0,00</strong></div>
          <button class="btn btn-dark" disabled style="opacity:0.4;cursor:not-allowed;width:100%;justify-content:center;">Pokračovať k pokladni</button>`;
      }
      return;
    }

    if (body) {
      body.classList.add('has-items');
      body.innerHTML = `<div class="mucumu-cart-items">` +
        cart.items.map(item => `
          <div class="mucumu-cart-item" data-key="${item.key}">
            <img src="${item.featured_image?.url || item.image}" alt="${item.product_title}" loading="lazy">
            <div>
              <div class="mucumu-cart-item-title">${item.product_title}</div>
              <div class="mucumu-cart-item-variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
              <div class="mucumu-cart-item-qty">
                <button class="mucumu-qty-btn" data-key="${item.key}" data-delta="-1">−</button>
                <span>${item.quantity}</span>
                <button class="mucumu-qty-btn" data-key="${item.key}" data-delta="1">+</button>
              </div>
              <button class="mucumu-cart-item-remove" data-key="${item.key}">Odstrániť</button>
            </div>
            <div class="mucumu-cart-item-price">${formatMoney(item.final_line_price)}</div>
          </div>`).join('') +
        `</div>`;
    }

    if (foot) {
      foot.innerHTML = `
        <div class="mucumu-subtotal">
          <span>Medzisúčet</span>
          <strong>${formatMoney(cart.total_price)}</strong>
        </div>
        <a href="/checkout" class="btn btn-dark" style="width:100%;justify-content:center;">Pokračovať k pokladni</a>
        <a href="/cart" class="btn btn-dark" style="width:100%;justify-content:center;">Zobraziť košík</a>`;
    }

    /* Update subtotal in drawer-foot (static element) */
    const drawerSubtotal = $('#drawer-subtotal');
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);

    /* Hide recs already in cart, show the rest */
    const cartProductIds = cart.items.map(i => String(i.product_id));
    const cartVariantIds = cart.items.map(i => String(i.variant_id));
    $$('.drawer-rec').forEach(rec => {
      const vid = rec.dataset.variantId;
      const pid = rec.dataset.productId;
      const inCart = cartVariantIds.includes(vid) || cartProductIds.includes(pid);
      rec.style.display = inCart ? 'none' : '';
    });

    // Bind qty and remove buttons
    $$('.mucumu-qty-btn', drawer).forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = Math.max(0, item.quantity + parseInt(btn.dataset.delta, 10));
        updateCartItem(key, newQty);
      });
    });
    $$('.mucumu-cart-item-remove', drawer).forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(console.error);
  }

  const openDrawer = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarWidth + 'px';
    $('.announce') && ($('.announce').style.paddingRight = scrollbarWidth + 'px');
    $('.nav') && ($('.nav').style.paddingRight = scrollbarWidth + 'px');
    drawer?.classList.add('is-open');
    drawerBackdrop?.classList.add('is-open');
    document.documentElement.classList.add('scroll-locked');
    fetchCart().then(renderCartDrawer).catch(console.error);
  };

  const closeDrawer = () => {
    drawer?.classList.remove('is-open');
    drawerBackdrop?.classList.remove('is-open');
    document.documentElement.classList.remove('scroll-locked');
    document.body.style.paddingRight = '';
    $('.announce') && ($('.announce').style.paddingRight = '');
    $('.nav') && ($('.nav').style.paddingRight = '');
  };

  $$('.bag-trigger').forEach(b => b.addEventListener('click', openDrawer));
  $('#drawer-close')?.addEventListener('click', closeDrawer);
  drawerBackdrop?.addEventListener('click', closeDrawer);

  /* Drawer rec "Pridať" buttons */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.drawer-rec-add');
    if (!btn) return;
    e.preventDefault();
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(r => r.json())
      .then(() => fetchCart())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
        btn.textContent = '✓';
        setTimeout(() => { btn.textContent = 'Pridať'; btn.disabled = false; }, 1400);
      })
      .catch(() => { btn.textContent = 'Pridať'; btn.disabled = false; });
  });

  /* Add to cart — gcard-plus button (Shopify AJAX) */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gcard-plus');
    if (!btn) return;
    if (btn.closest('#build-set-app')) return;
    e.preventDefault();
    e.stopPropagation();

    const card = btn.closest('.gcard, .scent-featured-card');
    const variantId = card?.dataset.variantId;
    if (!variantId) {
      // Fallback: bump count visually (for cards without variant data)
      const counts = $$('.bag-count');
      const c = parseInt(counts[0]?.textContent || '0', 10) + 1;
      updateCartCount(c);
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1400);
      return;
    }

    const origInner = btn.innerHTML;
    btn.innerHTML = '<span class="mucumu-loading"></span>';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(r => r.json())
      .then(() => fetchCart())
      .then(cart => {
        updateCartCount(cart.item_count);
        btn.innerHTML = origInner;
        btn.disabled = false;
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1400);
        openDrawer();
      })
      .catch(() => {
        btn.innerHTML = origInner;
        btn.disabled = false;
      });
  });

  /* gcard-add text button */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gcard-add');
    if (!btn) return;
    const card = btn.closest('.gcard');
    const variantId = card?.dataset.variantId;
    if (!variantId) return;
    e.preventDefault();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(r => r.json())
      .then(() => fetchCart())
      .then(cart => {
        updateCartCount(cart.item_count);
        const orig = btn.textContent;
        btn.textContent = '✓ Pridané';
        btn.classList.add('is-added');
        setTimeout(() => { btn.textContent = orig; btn.classList.remove('is-added'); }, 1400);
        openDrawer();
      })
      .catch(console.error);
  });

  /* ============================================================
     MOBILE MENU
  ============================================================ */
  const mob = $('#mobile-menu');
  $('.nav-hamburger')?.addEventListener('click', () => {
    mob?.classList.add('is-open');
    document.documentElement.classList.add('scroll-locked');
  });
  $('#mobile-close')?.addEventListener('click', () => {
    mob?.classList.remove('is-open');
    document.documentElement.classList.remove('scroll-locked');
  });

  /* ============================================================
     ESC KEY — closes all overlays
  ============================================================ */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      closeDrawer();
      closeModal();
      mob?.classList.remove('is-open');
      document.documentElement.classList.remove('scroll-locked');
    }
  });

  /* ============================================================
     NEWSLETTER FORM SUBMIT
  ============================================================ */
  $$('.signup-form').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn = form.querySelector('button[type="submit"]');
      if (!input || !input.value.trim() || !input.value.includes('@')) {
        input?.focus();
        return;
      }

      // Shopify customer subscribe — Klaviyo or native
      const orig = btn.textContent;
      btn.textContent = 'Ďakujeme';
      input.value = '';
      input.placeholder = 'Skontroluj svoj e-mail';
      setTimeout(() => {
        btn.textContent = orig;
        input.placeholder = 'tvoj@email.sk';
      }, 3000);
    });
  });

  /* ============================================================
     SCROLL REVEAL
  ============================================================ */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    $$('.reveal').forEach((el) => io.observe(el));
  }

  /* ============================================================
     GCARD VIDEO HOVER + PLUS BUTTON SETUP
     (for dynamically rendered cards not in Liquid)
  ============================================================ */
  function setupGcards(context) {
    $$(`.gcard`, context).forEach(card => {
      const img = card.querySelector('.gcard-image');
      if (!img) return;

      // Video hover
      if (!img.querySelector('.gcard-video')) {
        const vid = document.createElement('video');
        vid.className = 'gcard-video';
        vid.muted = true; vid.loop = true; vid.playsInline = true;
        if (card.dataset.video) vid.src = card.dataset.video;
        img.appendChild(vid);
        img.addEventListener('mouseenter', () => { if (vid.src) vid.play(); });
        img.addEventListener('mouseleave', () => { vid.pause(); vid.currentTime = 0; });
      }

      // Plus button (if not already in Liquid)
      if (!img.querySelector('.gcard-plus')) {
        const btn = document.createElement('button');
        btn.className = 'gcard-plus';
        btn.setAttribute('aria-label', 'Pridať do košíka');
        img.appendChild(btn);
      }
    });
  }

  setupGcards(document);

  /* ============================================================
     PDP — VARIANT CHANGE
  ============================================================ */
  const variantSelect = $('#mucumu-variant-select');
  const pdpPrice = $('.pdp-price');
  const pdpStock = $('.pdp-stock');
  const pdpAtb = $('#pdp-atb');
  const pdpStickyAtb = $('#pdp-sticky-atb');

  // Intercept scent swatch clicks — update hidden select + fire change (no page reload)
  const scentHeadLabels = $$('.pdp-scents-head span:last-child');
  $$('.scent-swatch').forEach(swatch => {
    swatch.addEventListener('click', (e) => {
      e.preventDefault();
      const vid = swatch.dataset.variantId;
      if (!vid || !variantSelect) return;
      variantSelect.value = vid;
      const hiddenId = $('#mucumu-variant-hidden');
      if (hiddenId) hiddenId.value = vid;
      variantSelect.dispatchEvent(new Event('change'));
      $$('.scent-swatch').forEach(s => s.classList.remove('is-active'));
      $$('.scent-swatch[data-variant-id="' + vid + '"]').forEach(s => s.classList.add('is-active'));
      const swatchName = swatch.querySelector('.scent-swatch-name')?.textContent || '';
      if (swatchName) scentHeadLabels.forEach(el => el.textContent = swatchName);
      // Update URL without reload
      const url = new URL(window.location.href);
      url.searchParams.set('variant', vid);
      window.history.replaceState({}, '', url.toString());
    });
  });

  if (variantSelect && window.MucumuVariants) {
    variantSelect.addEventListener('change', () => {
      const variant = window.MucumuVariants.find(v => String(v.id) === variantSelect.value);
      if (!variant) return;

      const hiddenId = $('#mucumu-variant-hidden');
      if (hiddenId) hiddenId.value = variant.id;

      // Switch gallery to variant's slides (filters + rebuilds dots)
      if (applyVariantGallery) applyVariantGallery(variant.id);

      // Switch olfactory pyramid
      document.querySelectorAll('[data-variant-pyramid]').forEach(grid => {
        grid.style.display = grid.dataset.variantPyramid === String(variant.id) ? '' : 'none';
      });

      if (pdpPrice) {
        pdpPrice.innerHTML = variant.compare_at_price
          ? `<span class="strike">${formatMoney(variant.compare_at_price)}</span>${formatMoney(variant.price)}`
          : formatMoney(variant.price);
      }

      if (pdpStock) {
        const available = variant.available;
        pdpStock.textContent = available ? 'Skladom' : 'Vypredané';
        pdpStock.closest('.mucumu-sold-out')?.classList.toggle('mucumu-sold-out', !available);
      }

      if (pdpAtb) {
        pdpAtb.disabled = !variant.available;
        pdpAtb.dataset.variantId = variant.id;
        pdpAtb.innerHTML = variant.available
          ? 'Pridať do košíka'
          : 'Vypredané';
      }

      /* Update volume tier prices */
      const volWidget = $('#vol-tiers');
      if (volWidget) {
        volWidget.dataset.unitPrice = variant.price;
        const tiers = volWidget.querySelectorAll('.vol-tier');
        tiers.forEach(tier => {
          const q = parseInt(tier.dataset.qty, 10) || 1;
          const discounts = { 1: 1, 2: 0.9, 3: 0.85 };
          const disc = discounts[q] || 1;
          const priceEl = tier.querySelector('.vol-tier-price');
          const oldEl = tier.querySelector('.vol-tier-old');
          if (priceEl) priceEl.textContent = formatMoney(Math.round(variant.price * q * disc));
          if (oldEl) oldEl.textContent = formatMoney(variant.price * q);
        });
      }

      /* Update variant-level INCI */
      const inciStore  = document.querySelector('.inci-store');
      const inciBtn    = document.querySelector('.btn-inci-trigger');
      if (inciStore && inciBtn) {
        const inciHtml = (window.MucumuVariantInci || {})[String(variant.id)] || '';
        inciStore.innerHTML = inciHtml;
        inciBtn.style.display = inciHtml ? '' : 'none';
      }
    });
  }

  /* PDP — scent/size selector radio groups */
  function radioGroup(sel) {
    const items = $$(sel);
    items.forEach((el) => {
      el.addEventListener('click', () => {
        items.forEach(i => i.classList.remove('is-active'));
        el.classList.add('is-active');
      });
    });
  }
  radioGroup('.pdp-scent-opt');
  radioGroup('.pdp-size');

  /* Scent selector label update */
  const scentLabel = $('.pdp-selector:nth-of-type(1) .selected');
  const sizeLabel = $('.pdp-selector:nth-of-type(2) .selected');
  $$('.pdp-scent-opt').forEach((el) => {
    el.addEventListener('click', () => {
      const name = el.querySelector('.name')?.textContent || '';
      const moods = { 'Soleille': 'slnečná', "L'Amour": 'romantická', 'Rouge': 'opulentná', 'Cashmere': 'jemná' };
      if (scentLabel) scentLabel.textContent = `${name} · ${moods[name] || ''}`;
    });
  });

  /* PDP — qty +/- */
  const qtyVal = $('#qty-val');
  $$('.pdp-qty button').forEach((b) => {
    b.addEventListener('click', () => {
      const delta = parseInt(b.dataset.qty, 10) || 0;
      const cur = parseInt(qtyVal?.textContent || '1', 10);
      const next = Math.max(1, Math.min(9, cur + delta));
      if (qtyVal) qtyVal.textContent = next;
      // Sync with form hidden input
      const hiddenQty = $('#mucumu-qty-input');
      if (hiddenQty) hiddenQty.value = next;
    });
  });

  /* PDP — volume discount tiers */
  const volTiers = $('#vol-tiers');
  if (volTiers) {
    volTiers.querySelectorAll('.vol-tier').forEach((tier) => {
      tier.addEventListener('click', () => {
        volTiers.querySelectorAll('.vol-tier').forEach((t) => t.classList.remove('is-active'));
        tier.classList.add('is-active');
        tier.querySelector('input[type="radio"]').checked = true;
        const qty = parseInt(tier.dataset.qty, 10) || 1;
        const qv = $('#qty-val');
        if (qv) qv.textContent = qty;
        const hi = $('#mucumu-qty-input');
        if (hi) hi.value = qty;
      });
    });
  }

  /* PDP Gallery — variant-aware click-zone slideshow */
  let applyVariantGallery = null;
  const galleryStack = $('#pdp-gallery-stack');
  if (galleryStack) {
    const allSlides = Array.from(galleryStack.querySelectorAll('.pdp-main-img'));
    const allThumbs = Array.from($$('.pdp-thumb'));
    const prevZone  = $('#pdp-nav-prev');
    const nextZone  = $('#pdp-nav-next');
    const dotsWrap  = $('#pdp-dots');

    let visSlides = [];
    let visThumbs = [];
    let visDots   = [];
    let currentVis = 0;

    function updateNav() {
      if (prevZone) prevZone.classList.toggle('is-hidden', currentVis === 0);
      if (nextZone) nextZone.classList.toggle('is-hidden', currentVis >= visSlides.length - 1);
    }

    function goToVis(idx) {
      if (idx < 0 || idx >= visSlides.length) return;
      visSlides[currentVis]?.classList.remove('is-active');
      visThumbs[currentVis]?.classList.remove('is-active');
      visDots[currentVis]?.classList.remove('is-active');
      currentVis = idx;
      visSlides[currentVis].classList.add('is-active');
      visThumbs[currentVis]?.classList.add('is-active');
      visDots[currentVis]?.classList.add('is-active');
      updateNav();
    }

    applyVariantGallery = function (variantId) {
      const vid = String(variantId);

      // Show/hide slides and thumbs for this variant
      allSlides.forEach(s => {
        const sv = s.dataset.forVariant || '';
        const show = sv === '' || sv === vid;
        s.style.display = show ? '' : 'none';
        s.classList.remove('is-active');
      });
      allThumbs.forEach(t => {
        const tv = t.dataset.forVariant || '';
        t.style.display = (tv === '' || tv === vid) ? '' : 'none';
        t.classList.remove('is-active');
      });

      // Rebuild visible sets
      visSlides = allSlides.filter(s => s.style.display !== 'none');
      visThumbs = allThumbs.filter(t => t.style.display !== 'none');

      // Rebuild dots for this variant's slide count
      if (dotsWrap) {
        dotsWrap.innerHTML = visSlides.length > 1
          ? visSlides.map((_, i) => `<span class="pdp-dot"></span>`).join('')
          : '';
        visDots = Array.from(dotsWrap.querySelectorAll('.pdp-dot'));
        visDots.forEach((dot, i) => {
          dot.style.pointerEvents = 'auto';
          dot.style.cursor = 'pointer';
          dot.addEventListener('click', () => goToVis(i));
        });
      } else {
        visDots = [];
      }

      // Rebind thumb clicks to visible indices
      visThumbs.forEach((thumb, i) => { thumb.onclick = () => goToVis(i); });

      // Reset to first visible slide
      currentVis = 0;
      visSlides[0]?.classList.add('is-active');
      visThumbs[0]?.classList.add('is-active');
      visDots[0]?.classList.add('is-active');
      updateNav();
    };

    // Prev / next always operate within visSlides
    if (prevZone) prevZone.addEventListener('click', () => goToVis(currentVis - 1));
    if (nextZone) nextZone.addEventListener('click', () => goToVis(currentVis + 1));

    // Touch swipe support
    let touchStartX = 0;
    let touchStartY = 0;
    let isSwiping = false;
    galleryStack.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
    }, { passive: true });
    galleryStack.addEventListener('touchmove', (e) => {
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
        isSwiping = true;
        e.preventDefault(); // stop the page from panning horizontally
      }
    }, { passive: false });
    galleryStack.addEventListener('touchend', (e) => {
      if (!isSwiping) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        goToVis(dx < 0 ? currentVis + 1 : currentVis - 1);
      }
      isSwiping = false;
    }, { passive: true });

    // Initialise with the current variant on page load
    applyVariantGallery(window.MucumuCurrentVariantId || '');

    // Tap-to-fullscreen lightbox
    const lb = document.createElement('div');
    lb.id = 'pdp-lightbox';
    lb.innerHTML = `
      <div class="pdp-lb-backdrop"></div>
      <div class="pdp-lb-frame">
        <img class="pdp-lb-img" src="" alt="">
        <button class="pdp-lb-close" aria-label="Zatvoriť">&#x2715;</button>
        <button class="pdp-lb-prev" aria-label="Predošlé">&#8249;</button>
        <button class="pdp-lb-next" aria-label="Nasledujúce">&#8250;</button>
      </div>`;
    document.body.appendChild(lb);

    const lbImg   = lb.querySelector('.pdp-lb-img');
    const lbClose = lb.querySelector('.pdp-lb-close');
    const lbPrev  = lb.querySelector('.pdp-lb-prev');
    const lbNext  = lb.querySelector('.pdp-lb-next');

    function lbGetSrc(slide) {
      const img = slide.querySelector('img');
      return img ? (img.dataset.src || img.src) : '';
    }
    function lbOpen(idx) {
      lbImg.src = lbGetSrc(visSlides[idx]);
      lb.classList.add('is-open');
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarWidth + 'px';
      $('.announce') && ($('.announce').style.paddingRight = scrollbarWidth + 'px');
      $('.nav') && ($('.nav').style.paddingRight = scrollbarWidth + 'px');
      document.documentElement.classList.add('scroll-locked');
      lbPrev.style.display = visSlides.length > 1 ? '' : 'none';
      lbNext.style.display = visSlides.length > 1 ? '' : 'none';
    }
    function lbClose_fn() {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('scroll-locked');
      document.body.style.paddingRight = '';
      $('.announce') && ($('.announce').style.paddingRight = '');
      $('.nav') && ($('.nav').style.paddingRight = '');
    }

    // Open on click (ignore if swipe just happened)
    galleryStack.addEventListener('click', () => {
      if (isSwiping) return;
      if (window.innerWidth > 768) return; // desktop: no lightbox
      lbOpen(currentVis);
    });

    lbClose.addEventListener('click', lbClose_fn);
    lb.querySelector('.pdp-lb-backdrop').addEventListener('click', lbClose_fn);
    lbPrev.addEventListener('click', (e) => { e.stopPropagation(); const i = (currentVis - 1 + visSlides.length) % visSlides.length; goToVis(i); lbImg.src = lbGetSrc(visSlides[i]); });
    lbNext.addEventListener('click', (e) => { e.stopPropagation(); const i = (currentVis + 1) % visSlides.length; goToVis(i); lbImg.src = lbGetSrc(visSlides[i]); });

    // Swipe inside lightbox
    let lbTouchX = 0;
    lb.addEventListener('touchstart', (e) => { lbTouchX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - lbTouchX;
      if (Math.abs(dx) > 50) {
        const i = dx < 0
          ? (currentVis + 1) % visSlides.length
          : (currentVis - 1 + visSlides.length) % visSlides.length;
        goToVis(i); lbImg.src = lbGetSrc(visSlides[i]);
      }
    }, { passive: true });

    // Close on Escape
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') lbClose_fn(); });
  }

  /* PDP sticky ATB visibility */
  const stickyAtb = $('#pdp-sticky-atb');
  const buyRow = $('.pdp-buy');
  if (stickyAtb && buyRow && 'IntersectionObserver' in window) {
    const stickyIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) stickyAtb.classList.remove('is-visible');
        else stickyAtb.classList.add('is-visible');
      });
    }, { threshold: 0.1 });
    stickyIO.observe(buyRow);
  }

  /* PDP ATB form submit */
  const pdpForm = $('[data-mucumu-form]'); /* matches id="product_form_<id>" via data attr */
  if (pdpForm) {
    // Intercept to open cart drawer after add — but use FormData so Bundler's
    // line_items/properties (quantity breaks) are included in the request
    pdpForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const variantId = pdpForm.querySelector('[name="id"]')?.value;
      const qty = parseInt(pdpForm.querySelector('[name="quantity"]')?.value || '1', 10);
      if (!variantId) return;

      if (pdpAtb) {
        const origHTML = pdpAtb.innerHTML;
        pdpAtb.innerHTML = '<span class="mucumu-loading"></span>';
        pdpAtb.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
        })
          .then(r => r.json())
          .then(() => fetchCart())
          .then(cart => {
            updateCartCount(cart.item_count);
            pdpAtb.innerHTML = origHTML;
            pdpAtb.disabled = false;
            openDrawer();
          })
          .catch(() => {
            pdpAtb.innerHTML = origHTML;
            pdpAtb.disabled = false;
          });
      }
    });
  }

  /* Upsell "Pridať do košíka" — intercept native form submit, use AJAX + open drawer */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.pdp-upsell-form');
    if (!form) return;
    e.preventDefault();

    const variantId = form.querySelector('[name="id"]')?.value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
    if (!variantId) return;

    const btn = form.querySelector('.pdp-upsell-btn');
    const origHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '<span class="mucumu-loading"></span>'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
    })
      .then(r => r.json())
      .then(() => fetchCart())
      .then(cart => {
        updateCartCount(cart.item_count);
        if (btn) {
          btn.innerHTML = '✓ Pridané';
          btn.classList.add('is-added');
          setTimeout(() => {
            btn.innerHTML = origHTML;
            btn.disabled = false;
            btn.classList.remove('is-added');
          }, 1400);
        }
        openDrawer();
      })
      .catch(() => {
        if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
      });
  });

  /* Collection tabs are now real <a> links with ?type= URL params — filtering is server-side Liquid */

  /* Init cart count on page load */
  fetchCart()
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});

  /* INCI Modal */
  const inciModal = $('#inci-modal');
  if (inciModal) {
    const inciBody = inciModal.querySelector('.inci-modal-body');
    const inciClose = inciModal.querySelector('.inci-modal-close');
    const inciBackdrop = inciModal.querySelector('.inci-modal-backdrop');

    function openInciModal(content) {
      inciBody.innerHTML = content;
      inciModal.setAttribute('aria-hidden', 'false');
      inciModal.classList.add('is-open');
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarWidth + 'px';
      $('.announce') && ($('.announce').style.paddingRight = scrollbarWidth + 'px');
      $('.nav') && ($('.nav').style.paddingRight = scrollbarWidth + 'px');
      document.documentElement.classList.add('scroll-locked');
    }

    function closeInciModal() {
      inciModal.classList.remove('is-open');
      inciModal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('scroll-locked');
      document.body.style.paddingRight = '';
      $('.announce') && ($('.announce').style.paddingRight = '');
      $('.nav') && ($('.nav').style.paddingRight = '');
    }

    // Trigger buttons inside accordions
    document.addEventListener('click', e => {
      const btn = e.target.closest('.btn-inci-trigger');
      if (btn) {
        const store = btn.closest('.pdp-acc-body') && btn.closest('.pdp-acc-body').querySelector('.inci-store');
        if (store) openInciModal(store.innerHTML);
      }
    });

    if (inciClose) inciClose.addEventListener('click', closeInciModal);
    if (inciBackdrop) inciBackdrop.addEventListener('click', closeInciModal);

    // Close on Escape key
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && inciModal.classList.contains('is-open')) closeInciModal();
    });
  }

  /* ============================================================
     VIDEO AUTOPLAY ON SCROLL
     Plays <video data-autoplay> when ≥50% visible; pauses when not.
  ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('video[data-autoplay]');
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play();
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.1 }
    );
    videos.forEach(function (video) {
      observer.observe(video);
    });
  });

  /* ============================================================
     SCENT ANCHOR LINKS — force reload when already on /collections/scents
     ============================================================ */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/collections/scents#"]');
    if (!link) return;
    if (window.location.pathname === '/collections/scents') {
      e.preventDefault();
      window.location.href = link.href;
      window.location.reload();
    }
  });

})();
